import React, { useState, useEffect ,useRef} from "react";
import { useMsal } from "@azure/msal-react";
import axios from "axios";
import { useTranslation } from "react-i18next"; 
import "./UserProfile.css";
import Avatar from "../../../Assets/default-avatar.png";
import { MoreHorizontalRegular } from "@fluentui/react-icons";

const UserMenu = () => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    imageUrl: "",
  });
  const authContext = useMsal();
  let accounts = authContext.accounts;
  let instance = authContext.instance;
  const activeAccount = accounts[0];
  //fermeture de menu 
  const toggleMenu = () => {
    setIsOpen((prev) => !prev);
  };
const menuRef = useRef(null);
const handleClickOutside = (event) => {
  // Vérifiez si le clic est en dehors du menu
  if (menuRef.current && !menuRef.current.contains(event.target)) {
    setIsOpen(false);
  }
};
useEffect(() => {
  // Ajouter un écouteur d'événement pour détecter les clics à l'extérieur
  document.addEventListener("mousedown", handleClickOutside);
  
}, []);

  // Récupérer la photo de profil utilisateur
  const fetchUserPhoto = (accessToken) => {
    return new Promise((resolve) => {
      const url = `https://graph.microsoft.com/v1.0/me/photos/48x48/$value`;
      axios
        .get(url, {
          headers: {
            Authorization: `Bearer ${accessToken}`,
            "Content-Type": "image/jpg",
          },
          responseType: "blob", // Traite la réponse comme un Blob pour afficher l'image
        })
        .then((response) => {
          if (response.status === 200) {
            // Si la requête est réussie, créez un objet URL pour l'image
            const imageUrl = URL.createObjectURL(response.data);
            resolve(imageUrl);
          } else {
            resolve(null);
          }
        })
        .catch((error) => {
          console.error("Erreur lors de la récupération de la photo :", error);
          resolve(null);
        });
    });
  };

  // Récupérer l'accessToken de profil utilisateur
  const getAccessToken = (msalInstance) => {
    return new Promise((resolve) => {
      const accessTokenRequest = {
        account: activeAccount,
      };
      // Tenter de récupérer le token d'accès de manière silencieuse
      msalInstance
        .acquireTokenSilent(accessTokenRequest)
        .then((response) => {
          resolve(response.accessToken); // Résoudre avec le token d'accès
        })
        .catch((error) => {
          console.error("Erreur lors de l'obtention du token d'accès :", error);
          resolve();
        });
    });
  };
  const generateInitialsAvatar = (name) => {
    const [firstName, lastName] = name.split(" ");
    const initials = (firstName?.charAt(0) || "") + (lastName?.charAt(0) || "");
    return initials.toUpperCase();
  };
  //api données utilisateurs

  const fetchUserData = () => {
    getAccessToken(instance).then((accessToken) => {
      // Tenter de récupérer la photo de profil
      fetchUserPhoto(accessToken).then((photoUrl) => {
        if (!photoUrl) {
          // Générer des initiales en cas d'absence de photo
          const initials = generateInitialsAvatar(activeAccount.name);
          photoUrl = `https://ui-avatars.com/api/?name=${encodeURIComponent(
            initials
          )}&background=random`;
        }

        // Met à jour l'état avec les informations utilisateur

        setUserData({
          name: activeAccount.name,
          email: activeAccount.username,
          imageUrl: photoUrl,
        });
      });
    });
  };

  useEffect(() => {
    if (instance) {
      fetchUserData();
    }
  }, [instance]);

  // logout
  const handleSignOut = () => {
    try {
      // Déconnexion via MSAL
      instance.logoutRedirect({
        postLogoutRedirectUri: "/", // Redirige vers la page d'accueil après logout
      });
    } catch (error) {
      console.error("Erreur lors du logout :", error);
    }
  };

  return (
    <div className={`user-menu-container ${isOpen ? "open" : ""}`} ref={menuRef} >
      <div className="user-info">
      
        <img
          src={userData.imageUrl || Avatar}
          alt="User Profile"
          className="user-image"
        />
        <div className="user-infos">
          <span className="user-name">{userData.name}</span>
        
        </div>

        <span className="icon" onClick={toggleMenu}>
          <MoreHorizontalRegular color="white" />
        </span>
      </div>
      {isOpen && (
        <div className="menu">
          <div className="menu-header">
          <div className="user-info">
        <img
          src={userData.imageUrl || Avatar}
          alt="User Profile"
          className="user-image"
        />
        <div className="user-infos">
          <span className="menu-name">{userData.name}</span>
        </div>
        
      </div>
            {/*}  <img
              src={userData.imageUrl}
              alt="User Profile"
              className="menu-image"
            />
            <div>
              <p className="menu-name">{userData.name}</p>
              <p className="menu-email">{userData.email}</p>
            </div>*/}
          </div>
          <button className="logout-button" onClick={handleSignOut}>
          {t("USER_MENU.LOGOUT")}
          </button>
        </div>
      )}
    </div>
  );
};

export default UserMenu;
